import { c as _c } from "react/compiler-runtime";
import type { IconProps } from './types';
export function IconSearch(props) {
  const $ = _c(3);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = <path d="M16.678 17.6071L10.963 11.8911C8.42063 13.6986 4.91739 13.2565 2.90383 10.8741C0.890265 8.49165 1.03812 4.96373 3.24396 2.75814C5.44922 0.551588 8.97748 0.403098 11.3603 2.41656C13.7432 4.43002 14.1856 7.93359 12.378 10.4761L18.093 16.1921L16.679 17.6061L16.678 17.6071ZM7.48596 3.00013C5.58966 2.9997 3.95365 4.33082 3.56843 6.18758C3.18321 8.04434 4.15467 9.91641 5.89463 10.6704C7.6346 11.4243 9.66486 10.853 10.7562 9.30219C11.8475 7.75141 11.7 5.64746 10.403 4.26414L11.008 4.86414L10.326 4.18414L10.314 4.17214C9.56574 3.41932 8.54735 2.99727 7.48596 3.00013Z" fill="currentColor" />;
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  let t1;
  if ($[1] !== props) {
    t1 = <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>{t0}</svg>;
    $[1] = props;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  return t1;
}